<div class="container " *ngIf="!otherProductType">
  <calsoft-breadcrumb [type]="'product'" (valueChange)='getProductTypeProduct($event)'></calsoft-breadcrumb>
</div>

<div ngClass.gt-md="container" class="padding-10" *ngIf="isEmpty">
  <div id="noProducts" fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
      <div>
        <img src="assets/images/no-product.png" alt="no-product">
      </div>
      <div class="notFound">
        <span>Sorry, no results found! </span>
      </div>
      <div class="spell">
        <span fxLayoutAlign="center center">Please check the spelling or try searching for something else </span>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="categoryProducts.length>0">
  <!-- <mat-card fxLayout="row" *ngIf="isEmpty" fxLayout.xs="column" fxLayoutAlign="start center">
    <p class="note-msg">
      <mat-icon><img src="assets/logo/light.png"></mat-icon> There are no
      products matching the selection.
    </p>
  </mat-card> -->



  <div ngClass.gt-md="container" ngClass.md="container" id="productsPage">
    <div class="inner-container ">
      <div *ngIf="!isEmpty">
        <div fxLayout="row wrap">
          <div *ngIf="data.disablePriceFilter==1" class="backg" fxHide.lt-md fxFlex.gt-md="20">
            <div *ngIf="priceEnabled">
              <mat-expansion-panel class="br0" style="border-radius: 0px;padding: 10px;"
                *ngIf="priceFrom != '' && priceFrom != undefined" expanded>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h5>Price</h5>

                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div fxLayout="column" fxLayoutGap="25px">
                  <div fxLayout="row" fxLayoutAlign="space-between center" class="text-muted">
                    <span style="letter-spacing: .3px;">From: <b> {{priceFrom |currencyConvert}}</b></span>
                    <span style="letter-spacing: .3px;">To: <b> {{priceTo |currencyConvert}}</b></span>
                  </div>
                  <div fxLayout="column" *ngIf="flag">
                    <nouislider #slider [config]="sliderConfig" (ngModelChange)="rangeChanged($event)"
                      [(ngModel)]="someRange2" class="marginT"></nouislider>
                    <div fxLayout="row" fxLayoutGap="10px">
                      <button [disabled]="filterMap.get('price')==undefined" color="primary" fxFlex mat-raised-button
                        (click)="applyPriceFilter()">Apply</button>
                      <button [disabled]="filterMap.get('price')==undefined" fxFlex (click)="clear()"
                        mat-raised-button>Clear</button>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
            <div *ngIf="data.showCategoryEnable==1">
              <calosft-sub-category-final [data]="data"></calosft-sub-category-final>
            </div>


            <div fxLayout="column" fxLayoutGap="0px">
              <mat-expansion-panel style="border-radius: 0px; padding-top: 10px;
              padding-bottom: 10px;" class="br0" expanded *ngFor="let item of attributeList | keyvalue;let i=index">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h5> {{item.key.replace('_', ' ') }}</h5>
                  </mat-panel-title>

                </mat-expansion-panel-header>
                <div fxLayout="row" fxLayoutAlign="center center">
                  <mat-form-field fxFlex="100" floatLabel="never">
                    <input style="letter-spacing: .3px;" matInput placeholder="Search For {{item.key}}"
                      [(ngModel)]="searchText[i+1]" [ngModelOptions]="{standalone: true}">
                  </mat-form-field>
                </div>
                <div class="overflowY" [config]="config">
                  <div class="padding-7" fxLayoutAlign="start center"
                    *ngFor="let size1 of item.value| filter:searchText[i+1]:'size1' ">

                    <mat-checkbox [checked]="filterCheckBox.indexOf(item.key+size1) >= 0" style="letter-spacing: .3px;"
                      (change)="filterColumn($event,item.key,i )" [value]="size1" color="primary">{{size1 |
                      texttransform}}

                    </mat-checkbox>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

          <div *ngIf="!isEmpty" fxFlex.lt-md="100" fxFlex.gt-sm class="all-products padding-2"
            ngClass.gt-sm="p-left padding-l16">
            <div *ngIf="data.disableSortParam==1" fxHide fxShow.lt-md class="filterProduct ">

              <div *ngIf="!otherProductType; else loggedOut">
                <div class="filtersticky" fxLayout="row">
                  <div matRipple (click)="sortMobile()" fxFlex=50 fxLayoutAlign="center center"
                    class="filterSort padding-10 backg">
                    <mat-icon>sort</mat-icon>&nbsp;<span>Sort</span>
                  </div>
                  <div [ngClass]="{'overlayProduct': searchUrl}" matRipple (click)="filters()" fxFlex=50
                    fxLayoutAlign="center center" class="filterSort1 padding-10 backg">
                    <mat-icon>filter_list</mat-icon>&nbsp;<span>Filter</span>
                  </div>
                </div>
              </div>
              <ng-template #loggedOut>

                <div class="commonHeader" fxLayout="row" fxLayoutAlign="space-between center">
                  <span style="    font-size: 19px;
                font-weight: 500;">{{headerName | uppercase}}</span>
                </div>

              </ng-template>
            </div>
            <div *ngIf="data.disableSortParam==1" fxHide fxShow.gt-sm fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center"
              class=" product-elevation mat-elevation-z1 text-muted">
              <button *ngIf="!sidenavOpen" mat-icon-button (click)="sidenav.toggle()">
                <mat-icon>more_vert</mat-icon>
              </button>
              <div>
                <a mat-button [matMenuTriggerFor]="sortMenu" #sortMenuTrigger="matMenuTrigger">
                  {{sort}}<mat-icon class="mat-icon-sm caret">arrow_drop_down</mat-icon>
                </a>
                <mat-menu #sortMenu="matMenu" xPosition="before" class="calsoft-dropdown" overlapTrigger="true">
                  <span (mouseleave)="sortMenuTrigger.closeMenu()">
                    <button mat-menu-item *ngFor="let sort of sortings" (click)="changeSorting(sort)">
                      <span>{{sort.viewValue}}</span>
                    </button>
                  </span>
                </mat-menu>
              </div>
              <div>

                <a mat-button *ngIf="counts.length>0" [matMenuTriggerFor]="countsMenu"
                  #countsMenuTrigger="matMenuTrigger">
                  Show {{size}}<mat-icon class="mat-icon-sm caret">arrow_drop_down</mat-icon>
                </a>
                <mat-menu #countsMenu="matMenu" xPosition="before" class="calsoft-dropdown" overlapTrigger="true">
                  <span>
                    <button mat-menu-item *ngFor="let countItem of counts" (click)="changeCount(countItem)">
                      <span>{{countItem}}</span>
                    </button>
                  </span>
                </mat-menu>
              </div>
            </div>


            <div style="padding: 0px 10px;" *ngIf="viewType == 'grid'&&!mobileScreen" fxHide fxShow.md fxShow.gt-md
              fxShow.lg fxShow.xl fxLayout="row wrap" class="products-wrapper  " id="categoryProducts">
              <!-- web screen type 1 -->

              <div *ngFor="let product of categoryProducts | paginate: config" fxFlex.xs="50" [fxFlex.lg]="viewCol"
                [fxFlex.gt-sm]="viewCol" fxFlex.lt-md="33.33" class="border-lb" class="col product-mobile backg">
                <calsoft-common-product-details-carousel [height]="productImageHeight" [name]="name"
                  [width]="productImageWidth" [imageType]="productImageType" [data]="data"
                  [manageNameSeperately]="manageNameSeperately" [type]="'product'"
                  [heightMobile]="productImageHeightMob" [widthMobile]="productImageWidthMob"
                  [showCartIcon]="showCartIcon" [showCartIncremented]="showCartIncremented" [product]="product"
                  [showConfigurableDropdown]="showConfigurableDropdown"></calsoft-common-product-details-carousel>

              </div>
            </div>

            <!-- mobile screen type 1 -->

            <div id="categoryProducts" style="padding: 0px 10px;" *ngIf="viewType == 'grid'&&mobileScreen" fxHide
              fxShow.lt-sm fxShow.sm fxShow.md fxLayout="row wrap" class="products-wrapper ">
              <div *ngFor="let product of categoryProducts" fxFlex.xs="50" [fxFlex.lg]="viewCol"
                [fxFlex.gt-sm]="viewCol" fxFlex.lt-md="33.33" class="border-lb" class="col product-mobile backg">


                <calsoft-common-product-details-carousel [type]="'product'" [name]="name"
                  [manageNameSeperately]="manageNameSeperately" [heightMobile]="productImageHeightMob"
                  [widthMobile]="productImageWidthMob" [data]="data" [height]="productImageHeight"
                  [width]="productImageWidth" [showConfigurableDropdown]="showConfigurableDropdown"
                  [showCartIcon]="showCartIcon" [showCartIncremented]="showCartIncremented"
                  [product]="product"></calsoft-common-product-details-carousel>

              </div>
            </div>

            <!-- web screen type 2 -->
            <div id="categoryProducts" *ngIf="viewType == 'list'&&!mobileScreen" fxLayout="row wrap" fxHide fxShow.md
              fxShow.gt-md fxShow.lg fxShow.xl class=" products-wrapper padding-l10">

              <div *ngFor="let product of categoryProducts | paginate: config " fxFlex.gt-md="50" fxFlex="100"
                class="col">

                <calsoft-common-product-details-grid [heightMobile]="productImageHeightMob"
                  [widthMobile]="productImageWidthMob" [height]="productImageHeight" [width]="productImageWidth"
                  [type]="'product'" [name]="name" [showConfigurableDropdown]="showConfigurableDropdown"
                  [showCartIcon]="showCartIcon" [data]="data" [showCartIncremented]="showCartIncremented"
                  [product]="product">
                </calsoft-common-product-details-grid>


              </div>

            </div>

            <!-- mobile screen type 2 -->
            <div id="categoryProducts" *ngIf="viewType == 'list'&&mobileScreen" fxLayout="row wrap" fxHide fxShow.lt-sm
              fxShow.sm fxShow.md class=" products-wrapper padding-l10">

              <div *ngFor="let product of categoryProducts" fxFlex.gt-md="50" fxFlex="100" class="col">

                <calsoft-common-product-details-grid [type]="'product'" [data]="data"
                  [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon"
                  [showCartIncremented]="showCartIncremented" [product]="product"></calsoft-common-product-details-grid>


              </div>

            </div>
            <div *ngIf="!isEmpty" fxHide fxShow.gt-sm fxLayout="row wrap">
              <div fxFlex="100">
                <div class="product-elevation text-center">
                  <pagination-controls class="product-pagination" autoHide="false" (pageChange)="onPageChanged($event)">
                  </pagination-controls>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</ng-container>

<div fxHide fxShow.lt-sm *ngIf="categoryProducts.length <= count">
  <div class="search-results" infiniteScroll (scrolled)="onScroll()">
    <div fxLayout=row fxLayoutAlign="center center" *ngIf="spinner !=false">

      <mat-spinner [diameter]="20"></mat-spinner>
      <!-- <mat-spinner  *ngIf="this.categoryProducts.length==this.count"></mat-spinner> -->
    </div>
  </div>
</div>



<div fxHide fxShow.lt-md fxLayout=row class="padding-10" *ngIf="this.categoryProducts.length==this.count"
  fxLayoutGap="10px" fxLayoutAlign="center center">

  <p>No more products</p>


</div>



<div fxLayout="row" fxLayoutAlign="center center" *ngIf="spinnerMain !=false" class="overlay">
  <mat-spinner color="primary" [diameter]="45" class="spinner">
  </mat-spinner>
</div>